import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH, MOBILE_QUERY_MAX_WIDTH_M } from "constants/vp-sizes";
import DesktopHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
const HEADER_LOGO_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
export const StyledSideBySideHubspotFormComponent = styled.div`
  max-width: ${({ maxWidth })=>maxWidth}px;
  margin: auto;
  &.align-to-logo {
    padding-left: ${HEADER_LOGO_HORIZONTAL_PADDING};
    padding-right: ${HEADER_LOGO_HORIZONTAL_PADDING};
  }
  .side-by-side-asset-and-paragraph {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${MOBILE_QUERY_MAX_WIDTH_M}) and (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .side-by-side-content.is-swap.is-mobile-swap .full-paragraph-component-wrapper {
      max-width: 550px;
      padding: 0;
    }
  }
`;
